<script setup>
const { t } = useI18n();
const route = useRoute();
const setI18nParams = useSetI18nParams();

import { pageTransition } from '~/helpers/animations/animations';

definePageMeta({
  pageTransition: pageTransition,
});

const videosQuery = gql`
  query videos {
    youtubeCategory {
      id
      title
      description
      videos {
        id
        title
        description
        url
      }
    }
  }
`;

const { data } = await useAsyncQuery(videosQuery);
const youtubeCategory = ref(data.value?.youtubeCategory);

const category = ref(youtubeCategory.value.find((cat) => useSlugify(cat.title) === route.params.category));
const video = ref(category.value.videos.find((video) => video.id === parseInt(route.params.id)));

const getVideoCode = (url) => {
  const parts = url.split('v=');
  return parts[1];
};

const breadcrumbs = [
  {
    title: t('pages.videogallery.title'),
    route: { name: 'videos' },
  },
  {
    title: category.value.title,
    route: { name: 'videos-category', params: { category: route.params.category } },
  },
  { title: video.value.title },
];
</script>

<template>
  <main class="main">
    <Breadcrumbs :items="breadcrumbs" />
    <div v-if="video" class="category__head">
      <h1 class="heading">{{ video.title }}</h1>
      <a href="https://www.youtube.com/channel/UCeYULpYNcpUJxSeK2FpDpsg" target="_blank" class="button button--tumbleweed">Sledujte na Youtube</a>
    </div>

    <div v-if="video" class="iframe">
      <iframe
        :src="`https://www.youtube.com/embed/${getVideoCode(video.url)}`"
        :title="video.title"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.category {
  border-top: 1px solid #000;
  padding-top: 10px;
  margin-top: 40px;

  h4 {
    font-weight: bold;
    margin-bottom: 16px;
  }
}

.category__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.iframe {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
